import { getRegionFromUrl } from "@certn/utils";

import { UserDetails } from "applicant-portal/src/types";

import i18n from "./i18n";

const DISMISSED_CANCELLED_CASES_KEY = "CERTN_dismissedCancelledCases";

export function createToken(input: string = "") {
  return window.btoa(input);
}

export function pendoMetadata(userDetails: UserDetails | undefined) {
  const visitorData = {
    id: userDetails?.auth0_id,
    email: userDetails?.auth0_email,
    // full_name: userDetails?.auth0_full_name,
    // primary_region: userDetails?.auth0_primary_region,
    locale: i18n.language,
    // created: userDetails?.created,
    // modified: userDetails?.modified,
    checks_ordered: userDetails?.subject?.check_types_run,
    region_from_url: getRegionFromUrl(),
  };

  return {
    visitor: visitorData,
  };
}

/**
 * Get all dismissed cancelled case IDs from localStorage
 */
export function getDismissedCancelledCases(): Record<string, boolean> {
  try {
    const stored = localStorage.getItem(DISMISSED_CANCELLED_CASES_KEY);
    return stored ? JSON.parse(stored) : {};
  } catch {
    return {};
  }
}

/**
 * Check if a cancelled case has been dismissed
 */
export function isCancelledCaseDismissed(caseId: string): boolean {
  const dismissedCases = getDismissedCancelledCases();
  return dismissedCases[caseId] === true;
}

/**
 * Mark a cancelled case as dismissed in localStorage
 */
export function dismissCancelledCase(caseId: string): void {
  try {
    const dismissedCases = getDismissedCancelledCases();
    dismissedCases[caseId] = true;
    localStorage.setItem(
      DISMISSED_CANCELLED_CASES_KEY,
      JSON.stringify(dismissedCases)
    );
  } catch (err) {
    console.error(
      "Failed to save dismissed cancelled case to localStorage",
      err
    );
  }
}
